:host {
  --uui-switch-inactive-background-color: var(--uui-theme-tertiary-900);
  --uui-switch-active-background-color: var(--uui-theme-core-900);
  --uui-switch-icon-background-color: var(--uui-white);
  --uui-switch-icon-background-color-checked: var(--uui-theme-on-secondary-600);
  --uui-switch-icon-box-shadow: var(--uui-theme-variant-600);
  --uui-switch-label-color: var(--uui-theme-variant-200);
}

:host {
  font-family: var(--uui-primary-font-family);
  display: flex;
  align-items: center;
}

input {
  appearance: none;
  width: 3.25rem;
  height: 1.5rem;
  border-radius: var(--uui-border-radius-lg);
  position: relative;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease-in-out;
  background: var(--uui-switch-inactive-background-color);
}

label {
  font-weight: var(--uui-font-weight-normal);
  color: var(--uui-switch-label-color);
  line-height: var(--uui-sm-line-height);
  margin-bottom: 0;
  margin-right: var(--uui-small-spacing);
  font-size: var(--uui-default-font-size);
}

input:focus {
  box-shadow: 0 0 0.125em 0.125em var(--uui-switch-icon-box-shadow);
}

input:checked {
  background: var(--uui-switch-active-background-color);
}

input::after {
  position: absolute;
  content: "";
  top: 0.1875rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  background: var(--uui-switch-icon-background-color);
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
}

input:checked::after {
  left: calc(100% - 1.3125rem);
  background: var(--uui-switch-icon-background-color-checked);
}

input:disabled {
  pointer-events: none;
  opacity: var(--uui-disabled-opacity);
}
